export default {
    actions: {
        setBreadcrumbItems(ctx, breadcrumbItems) {
            ctx.commit('updateBreadcrumbItems', breadcrumbItems)
        },
        setTotalPrice(ctx, totalPrice) {
            ctx.commit('updateTotalPrice', totalPrice)
        },
        setFinalPrice(ctx, finalPrice) {
            ctx.commit('updateFinalPrice', finalPrice)
        },
        setPayedAmount(ctx, payedAmount) {
            ctx.commit('updatePayedAmount', payedAmount)
        },
        setCustomerId(ctx, customerId) {
            ctx.commit('updateCustomerId', customerId)
        },
        setCashbackAmount(ctx, cashbackAmount) {
            ctx.commit('updateCashbackAmount', cashbackAmount)
        },
        setTaxAmount(ctx, taxAmount) {
            ctx.commit('updateTaxAmount', taxAmount)
        },
        setTaxPercent(ctx, taxPercent) {
            ctx.commit('updateTaxPercent', taxPercent)
        },
        setTaxPercentAmount(ctx, taxPercentAmount) {
            ctx.commit('updateTaxPercentAmount', taxPercentAmount)
        },
        setProductAmount(ctx, productAmount) {
            ctx.commit('updateProductAmount', productAmount)
        },
        setPayType(ctx, payType) {
            ctx.commit('updatePayType', payType)
        },
        setIsPayed(ctx, payType) {
            ctx.commit('updateIsPayed', payType)
        },
        setHasDiscount(ctx, payType) {
            ctx.commit('updateHasDiscount', payType)
        },
        setDiscountPercent(ctx, discountPercent) {
            ctx.commit('updateDiscountPercent', discountPercent)
        },
        setBonusPercentAmount(ctx, bonusPercentAmount) {
            ctx.commit('updateBonusPercentAmount', bonusPercentAmount)
        },
        setBonusSumAmount(ctx, bonusSumAmount) {
            ctx.commit('updateBonusSumAmount', bonusSumAmount)
        },
        setIsDisabledManuallyDiscount(ctx, isDisabledDiscountManually) {
            ctx.commit('updateIsDisabledManuallyDiscount', isDisabledDiscountManually)
        },
        setIsNeedIntegration(ctx, isNeedIntegration) {
            ctx.commit('updateIsNeedIntegration', isNeedIntegration)
        },
        setIsMakeSale(ctx, isMakeSale) {
            ctx.commit('updateIsMakeSale', isMakeSale)
        },
        setIsMakeDraftSale(ctx, isMakeDraftSale) {
            ctx.commit('updateIsMakeDraftSale', isMakeDraftSale)
        },
        setAdditionalInfoReceipt(ctx, additionalInfo) {
            ctx.commit('updateAdditionalInfo', additionalInfo)
        },
        setCurrentCurrencyShortName(ctx, currencyShortName) {
            ctx.commit('updateCurrentCurrencyShortName', currencyShortName)
        },
        setIsNeedFetch(ctx, isNeedFetch) {
            ctx.commit('updateIsNeedFetch', isNeedFetch)
        },
    },
    mutations: {
        updateBreadcrumbItems(state, breadcrumbItems) {
            state.breadcrumbItems = breadcrumbItems
        },
        updateTotalPrice(state, totalPrice) {
            state.totalPrice = totalPrice
        },
        updateFinalPrice(state, finalPrice) {
            state.finalPrice = finalPrice
        },
        updatePayedAmount(state, payedAmount) {
            state.payedAmount = payedAmount
        },
        updateCustomerId(state, customerId) {
            state.customerId = customerId
        },
        updateCashbackAmount(state, cashbackAmount) {
            state.cashbackAmount = cashbackAmount
        },
        updateTaxAmount(state, taxAmount) {
            state.taxAmount = taxAmount
        },
        updateTaxPercent(state, taxPercent) {
            state.taxPercent = taxPercent
        },
        updateTaxPercentAmount(state, taxPercentAmount) {
            state.taxPercentAmount = taxPercentAmount
        },
        updateProductAmount(state, productAmount) {
            state.productAmount = productAmount
        },
        updatePayType(state, payType) {
            state.payType = payType
        },
        updateIsPayed(state, isPayed) {
            state.isPayed = isPayed
        },
        updateHasDiscount(state, hasDiscount) {
            state.hasDiscount = hasDiscount
        },
        updateDiscountPercent(state, discountPercent) {
            state.discountPercent = discountPercent
        },
        updateBonusPercentAmount(state, bonusPercentAmount) {
            state.bonusPercentAmount = bonusPercentAmount
        },
        updateBonusSumAmount(state, bonusSumAmount) {
            state.bonusSumAmount = bonusSumAmount
        },
        updateIsDisabledManuallyDiscount(state, isDisabledDiscountManually) {
            state.isDisabledDiscountManually = isDisabledDiscountManually
        },
        updateIsNeedIntegration(state, isNeedIntegration) {
            state.isNeedIntegration = isNeedIntegration
        },
        updateIsMakeSale(state, isMakeSale) {
            state.isMakeSale = isMakeSale
        },
        updateIsMakeDraftSale(state, isMakeDraftSale) {
            state.isMakeDraftSale = isMakeDraftSale
        },
        updateAdditionalInfo(state, additionalInfo) {
            state.additionalInfo = additionalInfo
        },
        updateCurrentCurrencyShortName(state, currencyShortName) {
            state.currencyShortName = currencyShortName
        },
        updateIsNeedFetch(state, isNeedFetch) {
            state.isNeedFetch = isNeedFetch
        },
    },
    state: {
        breadcrumbItems: [],
        totalPrice: null,
        finalPrice: null,
        payedAmount: null,
        cashbackAmount: null,
        taxAmount: null,
        taxPercent: null,
        taxPercentAmount: null,
        productAmount: null,
        customerId: null,
        payType: null,
        isPayed: true,
        hasDiscount: false,
        discountPercent: null,
        bonusPercentAmount: null,
        bonusSumAmount: null,
        isDisabledDiscountManually: false,
        isNeedIntegration: false,
        isMakeSale: false,
        isMakeDraftSale: false,
        additionalInfo: null,
        currencyShortName: null,
        isNeedFetch: true
    },
    getters: {
        getBreadcrumbItems(state) {
            return state.breadcrumbItems
        },
        getTotalPrice(state) {
            return state.totalPrice
        },
        getFinalPrice(state) {
            return state.finalPrice
        },
        getPayedAmount(state) {
            return state.payedAmount
        },
        getCustomerId(state) {
            return state.customerId
        },
        getCashbackAmount(state) {
            return state.cashbackAmount
        },
        getTaxAmount(state) {
            return state.taxAmount
        },
        getTaxPercent(state) {
            return state.taxPercent
        },
        getTaxPercentAmount(state) {
            return state.taxPercentAmount
        },
        getProductAmount(state) {
            return state.productAmount
        },
        getPayType(state) {
            return state.payType
        },
        getIsPayed(state) {
            return state.isPayed
        },
        getHasDiscount(state) {
            return state.hasDiscount
        },
        getDiscountPercent(state) {
            return state.discountPercent
        },
        getBonusPercentAmount(state) {
            return state.bonusPercentAmount
        },
        getBonusSumAmount(state) {
            return state.bonusSumAmount
        },
        getIsDisabledManuallyDiscount(state) {
            return state.isDisabledDiscountManually
        },
        getIsNeedIntegration(state) {
            return state.isNeedIntegration
        },
        getIsMakeSale(state) {
            return state.isMakeSale
        },
        getIsMakeDraftSale(state) {
            return state.isMakeDraftSale
        },
        getAdditionalInfo(state) {
            return state.additionalInfo
        },
        getCurrentCurrencyName(state) {
            return state.currencyShortName
        },
        getIsNeedFetch(state) {
            return state.isNeedFetch
        },
    }
}
